







































import {
  defineComponent,
  computed,
  watch
} from '@vue/composition-api'

import OfferSelector from './OfferSelector.vue'
import AnslPageCf from '@/components/AnslPageCf.vue'
import PriceCalculationFooter from './PriceCalculationFooter.vue'
import TermsAndConditions from './TermsAndConditions.vue'

import {
  getAreaInfo,
  getLoading as getAreaLoading,
  getException as getAreaException
} from '@/store/modules/area.store'

import {
  getSelectedOffer,
  getSelectedAlternativeDelivery,
  getSelectedOperatorChangeDate
} from '@/store/modules/order-flow.store'

import {
  accessorFactory,
  Namespace
} from '@/store'

import { RouteName } from '@/router'

import AnalyticsService from '@/services/analytics.service'
import {
  isAreaTypeChangeOperator,
  isAreaTypeFwa
} from '@/utils/area.utils'
import {
  AreaInfoResponse,
  OrderPageContent
} from '@/types'

import beforeRouteEnter from './order-flow-route-guard'

const {
  fetchContent,
  getContent,
  getLoading: getContentLoading,
  getException: getContentException
} = accessorFactory<OrderPageContent, { areaType: string; areaStatus: string }>(Namespace.OrderPage)

export default defineComponent({
  components: {
    AnslPageCf,
    OfferSelector,
    TermsAndConditions,
    PriceCalculationFooter
  },
  beforeRouteEnter,
  setup (_, context) {
    const store = context.root.$store
    const router = context.root.$router
    const areaInfo = computed(() => getAreaInfo(store))
    const termsInfo = computed(() => getContent(store)?.termsInfo || '')
    const banner = computed(() => getContent(store)?.banner || {})

    const loaded = computed(
      () => !getAreaLoading(store)
        && !getAreaException(store)
        && !getContentLoading(store)
        && !getContentException(store)
    )

    const loading = computed(() => getAreaLoading(store) || getContentLoading(store))
    const exception = computed(() => getAreaException(store) || getContentException(store))

    enum tabListOptions {
      OFFERS = 'Beställningsalternativ',
      TERMS = 'Villkor'
    }

    const offer = computed(() => getSelectedOffer(store))
    const operatorChangeDate = computed(() => getSelectedOperatorChangeDate(store))
    const alternativeDelivery = computed(() => getSelectedAlternativeDelivery(store))
    const hasSpecialCampaign = computed(() => areaInfo.value?.HasSpecialCampaign)
    const isPriceCalculationFooterVisible = computed(() => {
      if (isAreaTypeChangeOperator(areaInfo.value.AreaTypeName)) {
        return offer.value && operatorChangeDate.value
      }
      return offer.value
    })

    const onAreaInfo = (newAreaInfo: AreaInfoResponse) => {
      const { AreaStatusName, AreaTypeName } = newAreaInfo

      if (AreaStatusName && AreaTypeName) {
        fetchContent(
          store,
          {
            areaType: AreaTypeName,
            areaStatus: AreaStatusName
          }
        )
      }
    }

    onAreaInfo(areaInfo.value)

    const goFurther = () => router.push({ name: RouteName.OrderDetailsPage })

    watch(() => getAreaInfo(store), onAreaInfo)

    AnalyticsService.collect(areaInfo.value.AreaTypeName)

    return {
      areaInfo,
      termsInfo,
      tabListOptions,
      offer,
      alternativeDelivery,
      goFurther,
      banner,
      loaded,
      loading,
      exception,
      hasSpecialCampaign,
      isPriceCalculationFooterVisible,
      isAreaTypeChangeOperator,
      isAreaTypeFwa
    }
  }
})
